import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/iwwgeneral";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/iwwtencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/iwwelegibilityproject";
import TODIS_FORM_INDICATORS from "./form/GENERAL/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/LIWW/status";
import { TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_LIVE_FUND from "./form/LIWW/lFundingsources";
import TODIS_TECH_DOCU from "./form/LIWW/lTechnicalDocumentation";
import TODIS_TIMELINE from "./form/GENERAL/lTimeline";
import TODIS_FORM_OTHER_IWWP from "./form/LIWW/other";
import { loadModules } from 'esri-loader';


const TODIS_FORM_LIWW = ({ errors, touched, status, setFieldValue, values }) => {
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)

    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/29";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `live_iww_proj_id=${values.liveIwwProjId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })
    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const descriptionTooltip = (
        <Tooltip id="description-tooltip">
            Project description
        </Tooltip>
    )

    const statusTooltip = (
        <Tooltip id="status-tooltip">
            Project implementation status
        </Tooltip>
    )

    const tentIndicatorsTooltip = (
        <Tooltip id="tent-indicators-tooltip">
            The TEN-T indicators the project will be addressing
        </Tooltip>
    )

    const tentComplianceTooltip = (
        <Tooltip id="tent-compliance-tooltip">
            Current compliance of the IWW section the project is related to
        </Tooltip>
    )

    const perfIndicatorsTooltip = (
        <Tooltip id="perfIndicators-tooltip">
            Project's compliance indicators
        </Tooltip >
    )

    const fundSourcesTooltip = (
        <Tooltip id="fundSources-tooltip">
            Project's funding sources
        </Tooltip>
    )

    const techDocuTooltip = (
        <Tooltip id="techDocu-tooltip">
            Project's technical documentation
        </Tooltip>
    )

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );


    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title={
                <OverlayTrigger placement="top" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="" values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lDescritpion" title={
                <OverlayTrigger placement="top" overlay={descriptionTooltip}>
                    <div>Description</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmDescDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwLivePmDescDTO.remarks" label="Remarks" name="iwwLivePmDescDTO.remarks" disabled={status} />
                            {errors.iwwLivePmDescDTO && errors.iwwLivePmDescDTO.remarks && touched.iwwLivePmDescDTO && touched.iwwLivePmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwLivePmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lStatus" title={
                <OverlayTrigger placement="top" overlay={statusTooltip}>
                    <div>Status</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lFund" title={
                <OverlayTrigger placement="top" overlay={fundSourcesTooltip}>
                    <div>Funding sources</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_LIVE_FUND errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>

            <Tab eventKey="lTechDocu" title={
                <OverlayTrigger placement="top" overlay={techDocuTooltip}>
                    <div>Technical documentation</div>
                </OverlayTrigger>
            }>
                <TODIS_TECH_DOCU errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTimeline" title="Timeline">
                <TODIS_TIMELINE errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lElegibilityProject" title={
                <OverlayTrigger placement="bottom" overlay={tentIndicatorsTooltip}>
                    <div>Targeted TEN-T indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmEligiTentDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwLivePmEligiTentDTO.remarks" label="Remarks" name="iwwLivePmEligiTentDTO.remarks" disabled={status} />
                            {errors.iwwLivePmEligiTentDTO && errors.iwwLivePmEligiTentDTO.remarks && touched.iwwLivePmEligiTentDTO && touched.iwwLivePmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwLivePmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lTenCompliance" title={
                <OverlayTrigger placement="bottom" overlay={tentComplianceTooltip}>
                    <div>TEN-T compliance of the related IWW section</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmTentcompDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwLivePmTentcompDTO.remarks" label="Remarks" name="iwwLivePmTentcompDTO.remarks" disabled={status} />
                            {errors.iwwLivePmTentcompDTO && errors.iwwLivePmTentcompDTO.remarks && touched.iwwLivePmTentcompDTO && touched.iwwLivePmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwLivePmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmPiDTO" Name1="forecastTrainTraffic" Name2="actualTrainTraffic" Label1="Traffic - forecasted" Label2="Traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwLivePmPiDTO.remarks" label="Remarks" name="iwwLivePmPiDTO.remarks" disabled={status}/>
                            {errors.iwwLivePmPiDTO && errors.iwwLivePmPiDTO.remarks && touched.iwwLivePmPiDTO && touched.iwwLivePmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwLivePmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab> */}
            <Tab eventKey="lIndicators" title={
                <OverlayTrigger placement="bottom" overlay={perfIndicatorsTooltip}>
                    <div>Performance indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="iwwLivePmIndicatorsDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwLivePmIndicatorsDTO.remarks" label="Remarks" name="iwwLivePmIndicatorsDTO.remarks" disabled={status} />
                            {errors.iwwLivePmIndicatorsDTO && errors.iwwLivePmIndicatorsDTO.remarks && touched.iwwLivePmIndicatorsDTO && touched.iwwLivePmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwLivePmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }>
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_IWWP errors={errors} touched={touched} disabled={status} TypeForm="iwwLiveOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}
export default TODIS_FORM_LIWW;